export default __webpack_public_path__ + "static/media/template2.9dfc6f72.svg";